import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    if (typeof SignaturePad !== 'undefined') {
      const canvas = this.element.querySelector("#student-signature-canvas");
      
      if (canvas) {
        this.signaturePad = new SignaturePad(canvas);
      }
    }
  }

  clearSignature(event) {
    if (this.signaturePad) {
      this.signaturePad.clear();
    }
  }

  saveSignature(event) {
    if (!this.signaturePad) {
      event.preventDefault();
      alert("Signature pad not initialized. Please refresh the page.");
      return;
    }

    // Check if signature is empty
    if (this.signaturePad.isEmpty()) {
      event.preventDefault();
      alert("Please sign before submitting");
      if (event.currentTarget) {
        event.currentTarget.disabled = false;
      }
      return;
    }

    // Save the signature value to the hidden field
    const signatureInput = this.element.querySelector("#student_signature");
    if (signatureInput) {
      signatureInput.value = this.signaturePad.toDataURL();
    }

    // Allow form submission to proceed
  }
}

